// External Dependencies:
const escapeHtml = require( 'escape-html' )

export function templateReplace( templateString, values ) {
	// Defaults:
	templateString = templateString || ''
	values = values || {}

	// Regex to match plain text placeholders:
	// #{text}
	const escapeRegex = /#\{([^{}]*)}/g

	// Replace (escape)
	const escapeReplace = ( str, match ) => {
		var value = values[ match ]

		return ( typeof value === 'string' || typeof value === 'number' ) ? escapeHtml( value ) : str
	}

	// Apply replacements:
	templateString = templateString.replace( escapeRegex, escapeReplace )

	return templateString
}
